import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArYodaRulesCreatedNotifyApproversProps extends BaseTemplateProps {
  request: {
    name: string
  }
  createdBy: {
    name: string
  }
}

export const ArYodaRulesCreatedNotifyApprovers: TemplateDefinition<ArYodaRulesCreatedNotifyApproversProps> =
  {
    renderParams: (props: ArYodaRulesCreatedNotifyApproversProps) => ({
      messageKey: 'notificationsDomain.templates.arYodaRulesCreatedNotifyApprovers',
      values: {
        ruleName: props?.request?.name,
        createdBy: props?.createdBy?.name,
      },
    }),
    getLink: (props: ArYodaRulesCreatedNotifyApproversProps): string => {
      if (!props) return ''
      return '/app/admin/approvals-management/approval-requests-search?tool=yoda_rules'
    },
  }
